"use client";

import { c as _c } from "react/compiler-runtime";
import { m, useReducedMotion } from "motion/react";
import LandingNavButtons from "@/components/navigation/landing-nav-buttons";
import { useSessionReader } from "@/hooks/use-session-reader";
export default function LandingNavAuth(t0) {
  const $ = _c(10);
  const {
    hideSubscribe
  } = t0;
  const reader = useSessionReader();
  const reduceMotion = useReducedMotion();
  if (reader === undefined) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 1,
      y: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reduceMotion) {
    t2 = reduceMotion ? false : {
      opacity: 0
    };
    $[1] = reduceMotion;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.2,
      ease: "easeOut"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hideSubscribe || $[5] !== reader.isAuthenticated) {
    t4 = <LandingNavButtons hideSubscribe={hideSubscribe} loggedIn={reader.isAuthenticated} />;
    $[4] = hideSubscribe;
    $[5] = reader.isAuthenticated;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <m.div animate={t1} className="z-10 flex gap-2" initial={t2} transition={t3}>{t4}</m.div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}